import { jsx as _jsx } from "react/jsx-runtime";
import { HelixToggleButton, HelixToggleButtonGroup } from './ToggleButton.components';
import { Tooltip } from '../Tooltip';
/**
 * Toggle button group.
 */
export const ToggleButton = ({ ariaLabel, buttons, dataId, defaultValue = null, onChange, style }) => {
    /**
     * Handler called when selected toggle changes.
     * @param value The selected toggle.
     */
    const handleOnChange = (value) => {
        if (onChange)
            onChange(value);
    };
    return (_jsx(HelixToggleButtonGroup, Object.assign({ "aria-label": ariaLabel, "data-id": `${dataId}-group`, role: "group", sx: style }, { children: buttons.map((toggleButton, i) => {
            const dataIdPrefix = `${dataId}-button-${toggleButton.value}`;
            const selected = defaultValue === toggleButton.value;
            const button = (_jsx(HelixToggleButton, Object.assign({ "data-id": dataIdPrefix, "aria-label": toggleButton.label, "aria-pressed": selected, disabled: toggleButton.disabled || selected, onClick: () => handleOnChange(toggleButton.value) }, { children: toggleButton.icon }), `${dataId}-button-${i}`));
            return !toggleButton.disabled && !selected ? (_jsx(Tooltip, Object.assign({ title: toggleButton.label }, { children: button }), `${dataId}-button-${i}`)) : (button);
        }) })));
};
export default ToggleButton;
